import { Navigate, Route, Routes } from 'react-router';
import AppShell from './auth/AppShell';
import RequireAdmin from './auth/RequireAdmin';
import RequireAuth from './auth/RequireAuth';
import DayPage from './pages/DayPage';
import DayDigibordPage from './pages/DayDigibordPage';
import DigibordPage from './pages/DigibordPage';
import LoginPage from './pages/LoginPage';
import RoosterPage from './pages/RoosterPage';
import WeekPage from './pages/WeekPage';
import AccessPanel from './pages/panels/AccessPanel';
import LooksPanel from './pages/panels/LooksPanel';
import PanelLayout from './pages/panels/PanelLayout';
import PeriodsPanel from './pages/panels/PeriodsPanel';
import SubjectsPanel from './pages/panels/SubjectsPanel';
import { currentWeek } from './planner/weekMath';

/** The main screen is the current week. */
function ThisWeek() {
  const now = currentWeek();
  return <Navigate to={`/week/${now.year}/${now.week}`} replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        {/* The digibord is a clean full-screen view without the navigation. */}
        <Route path="/week/:jaar/:week/digibord" element={<DigibordPage />} />
        <Route path="/week/:jaar/:week/dag/:dag/digibord" element={<DayDigibordPage />} />
        <Route element={<AppShell />}>
          <Route path="/" element={<ThisWeek />} />
          <Route path="/week/:jaar/:week" element={<WeekPage />} />
          <Route path="/week/:jaar/:week/dag/:dag" element={<DayPage />} />
          <Route path="/rooster" element={<RoosterPage />} />
          <Route element={<PanelLayout />}>
            <Route path="/instellingen" element={<Navigate to="/instellingen/vakken" replace />} />
            <Route path="/instellingen/vakken" element={<SubjectsPanel />} />
            <Route path="/instellingen/tijdvakken" element={<PeriodsPanel />} />
            <Route path="/instellingen/thema" element={<LooksPanel />} />
            <Route element={<RequireAdmin />}>
              <Route path="/toegang" element={<AccessPanel />} />
            </Route>
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}
